import axios from 'axios';
import Qs from 'qs';
import { Toast, Dialog } from 'vant';
import Vue from 'vue';

import store from '@/store';

const ajax = axios.create({
    baseURL: '/api',
    withCredentials: true,
    timeout: 120000
});

// 跳转到登录页
function locationToLogin() {
    if (location.href.indexOf("login") < 0) {
        location.href = "/login/?callback="+encodeURIComponent(location.pathname + location.search);
    }
}
ajax.interceptors.request.use(
    config => {
        if (store.getters.token) {
            config.headers['X-Token'] = 'getToken()';
            // 临时增加token参数
            if (!config.params) {
                config['params'] = {}
            }
            config.params['token'] = store.getters.token;
            config.params['d'] = new Date().getTime();
        }
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        config.transformRequest = [function(data) {
            // 在请求之前对data传参进行格式转换
            data = Qs.stringify(data);

            return data;
        }]

        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

ajax.interceptors.response.use(
    response => {
        let res = response.data;

        // 如果返回code不是0，则为错误；
        if (res.code !== 0) {
            let errmsg = ''

            // 如果当前页面不是登录页。就跳转到登录页
            if (res.code === 105011001 || res.code == 301) {
                locationToLogin();
                // 清除一下用户的token
                store.dispatch("user/resetToken");

                return Promise.reject("");
            }
            if (res.error && res.error.length > 0) {
                errmsg = res.error[0].value;
            }

            Toast.fail(errmsg || res.msg || 'Error');
            // 非法登录、其他客户端登录、令牌过期
            if (res.code === 302 || res.code === 508 || res.code === 512 || res.code === 514) {

                Dialog.confirm({
                        message: '当前账号已退出登录，您可以取消停留在这个页面或者是重新登录',
                        confirmButtonText: "重新登录"
                    })
                    .then(() => {
                        store.dispatch('user/resetToken').then(() => {
                            location.reload();
                        })
                    })
            }
            return Promise.reject(new Error(errmsg || res.msg || 'Error'));
        } else {
            return res;
        }
    },
    error => {
        Toast.fail(error.message);
        return Promise.reject(error);
    }
)

export default ajax;
